import React from 'react';
import { RatingsData } from 'types/feedback/feedbackTypes';

const CustomerRatings: React.FC<RatingsData> = ({ averageRating, totalRatings, ratingsBreakdown }) => {
  // Handle fractional stars by rounding down the filled stars
  const getStarClass = (index: number) => {
    return averageRating >= index + 1 ? 'filled' : averageRating >= index + 0.5 ? 'half-filled' : '';
  };

  return (
    <div className="customer-ratings-container">
      <div className="overall-rating">
        <h2>{averageRating.toFixed(1)}</h2>
        <div className='stars'>
          <div className="star-ratings">
            {Array.from({ length: Math.ceil(averageRating) }, (_, i) => (
              <span key={i} className={`star ${getStarClass(i)}`}>★</span>
            ))}
          </div>
          <p>Based on {totalRatings} Ratings</p>
        </div>
      </div>

      <div className="ratings-breakdown">
        {Array.from({ length: 6 }, (_, star) => (
          <div key={star} className="rating-row">
            <span>{star} STARS</span>
            <div className="rating-bar">
              <div
                className={`bar filled-${star+1}`}
                style={{ width: `${(ratingsBreakdown[star] ?? 0) / totalRatings * 100}%` }}
              ></div>
            </div>
            <span>{ratingsBreakdown[star] ?? 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerRatings;
